import { render, staticRenderFns } from "./DreamsLog.vue?vue&type=template&id=c3c9f620&scoped=true"
import script from "./DreamsLog.vue?vue&type=script&lang=js"
export * from "./DreamsLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c9f620",
  null
  
)

export default component.exports